import { openFile } from 'common'
import { ApiEndpoints, Copia } from 'models'
import { apiGet, apiGetText } from 'services/api'

export async function getCopies(variables: {
  filtre: object
  pagination: object
}): Promise<{ status: number; documents: Copia[]; totalDocuments: number; totalPages: number }> {
  const params = Object.values(variables.filtre).every((value) => value === '')
    ? { pagination: variables.pagination }
    : variables

  return apiGet(ApiEndpoints.getCopies, params as any)
    .then((response) => {
      return { status: response.status, ...response.body }
    })
    .catch((err) => {
      throw err
    })
}

export async function downloadDocument(variables: { uuid: string }) {
  const path = `${ApiEndpoints.downloadCopy}/${variables.uuid}`

  return apiGetText(path)
    .then((response) => {
      if (!response.body) return
      openFile(response.body)
    })
    .catch((err) => {
      throw err
    })
}

export async function downloadCopiesCSV(variables: {
  filtre: object
}): Promise<string | undefined> {
  const params = Object.values(variables.filtre).every((value) => value === '')
    ? undefined
    : variables

  return apiGetText(ApiEndpoints.getCopiesCSV, params)
    .then((response) => {
      if (!response.body) return
      return response.body
    })
    .catch((err) => {
      throw err
    })
}
